import { ColumnId } from "components/DragDropList/types";
import { ArrowBoxColored } from "components/icons/generated";

import DropEmptyState from ".";

const DropEmptyStateDoubleColumn = ({
  isDragActive,
  columnId,
}: {
  isDragActive: boolean;
  columnId: ColumnId;
}) => (
  <DropEmptyState
    padding="large"
    isDragActive={isDragActive}
    icon={ArrowBoxColored}
    caption={
      columnId === ColumnId.First
        ? "Drag & Drop a feature from the section below if you want to show it"
        : "Drag & Drop a feature from the section above if you want to hide it"
    }
    dropCaption="You can drop the feature here"
  />
);

export default DropEmptyStateDoubleColumn;
